import { IPasteSpecialContext, IPasteSpecialStrategy } from './interface';

// 策略环境类
export default class PasteSpecial implements IPasteSpecialContext {
    // 具体粘贴策略
    private pasteSpecialStrategy: IPasteSpecialStrategy;

    /**
     * 设置具体粘贴策略
     * @param strategy 具体粘贴策略
     */
    public setStrategy(strategy: IPasteSpecialStrategy) {
        this.pasteSpecialStrategy = strategy;
    }

    /**
     * 执行具体策略
     */
    public executePaste(): void {
        this.pasteSpecialStrategy.paste();
    }
}

